/* eslint-disable react/jsx-no-undef */
/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import styled from "styled-components";
import { DataGrid, GridPinnedColumnFields } from "@mui/x-data-grid";
import { GridColDef, GridCellParams } from "@mui/x-data-grid-pro";
import defaultlogo from "../../../assets/icons/noimg.png";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    IconButton,
    Popper,
    TextField,
    Tooltip,
    Badge,
    Select,
    MenuItem,
    SelectChangeEvent,
    InputBase,
    DialogContent,
    DialogContentText,
    Backdrop
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import {
    approveAndRejectApi,
    partnerApi,
    updateAuditStatyByQH
} from "../../Services/Partner/Partner";
import { showToast } from "../../../Components/Toast";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../../assets/images/image.png";
import PartnerDetailsDrawer from "../PartnerDetails/PartnerDetailsDrawer";
import { fetchDataForDisplayDataInDropDownApi } from "../../Services/Filter/Filter";
import {
    notificationApi,
    notificationUpdateReadStatusApi
} from "../../Services/Notification/Notification";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGridPro, GridPinnedRowsProp } from "@mui/x-data-grid-pro";
import InfoIcon from "@mui/icons-material/Info";
import oligasIcn from "../../../assets/icons/oligas.png";
import evAutoIcn from "../../../assets/icons/automotive.png";
import power from "../../../assets/icons/power.png";
import industry from "../../../assets/icons/industry.png";
import aerospace from "../../../assets/icons/aerospace.png";
import confirmImg from "../../../assets/images/confirm.png";
import {
    generatePartnerRegistrationFile,
    getLoggedInEmail,
    getLoggedInUserID,
    Management,
    NPDManager,
    NPDManagerHead,
    productionManager,
    productionManagerHead,
    qualityManager,
    qualityManagerHead,
    sourcingManager,
    sourcingManagerHead
} from "../../../Utils/Constant";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { WebsocketContext } from "../../../App";
import { Link } from "react-router-dom";
import CircleIcon from "@mui/icons-material/Circle";
import dayjs from "dayjs";

const locationOptions = [
    { title: "Andhra Pradesh" },
    { title: "Arunachal Pradesh" },
    { title: "Assam" },
    { title: "Bihar" },
    { title: "Chhattisgarh" },
    { title: "Goa" },
    { title: "Gujarat" },
    { title: "Haryana" },
    { title: "Himachal Pradesh" },
    { title: "Jharkhand" },
    { title: "Karnataka" },
    { title: "Kerala" },
    { title: "Madhya Pradesh" },
    { title: "Maharashtra" },
    { title: "Manipur" },
    { title: "Meghalaya" },
    { title: "Mizoram" },
    { title: "Nagaland" },
    { title: "Odisha" },
    { title: "Punjab" },
    { title: "Rajasthan" },
    { title: "Sikkim" },
    { title: "Tamil Nadu" },
    { title: "Telangana" },
    { title: "Tripura" },
    { title: "Uttar Pradesh" },
    { title: "Uttarakhand" },
    { title: "West Bengal" },
    { title: "Andaman and Nicobar Islands" },
    { title: "Chandigarh" },
    { title: "Dadra and Nagar Haveli and Daman and Diu" },
    { title: "Lakshadweep" },
    { title: "Delhi" },
    { title: "Puducherry" },
    { title: "Ladakh" },
    { title: "Jammu and Kashmir" }
];

const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
    borderRadius: "5px",
    marginTop: "16px",
    background: "#fff",
    padding: "15px"
}));
interface LayoutProps {
    updateIsReadStatus: boolean;
    setUpdateIsReadStatus: (value: boolean) => void;
}
const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
        borderColor: "#fff"
    }
}));
export const PartnerDatabase: React.FC<LayoutProps> = ({
    updateIsReadStatus,
    setUpdateIsReadStatus
}) => {
    const { messages } = useContext(WebsocketContext);
    let initialValue = "1"; // Default

    if (sourcingManagerHead()) {
        initialValue = "1";
    } else if (qualityManager() || qualityManagerHead()) {
        initialValue = "2";
    } else if (sourcingManager()) {
        initialValue = "3";
    }

    const [value, setValue] = React.useState(initialValue);
    const loggedinguserid = getLoggedInUserID();
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<string[]>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [selectedRowsForAcceptAndReject, selSelectedRowsForAcceptAndReject] =
        useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndustry, setSelectedIndustry] = useState([]);
    const [selectedSolution, setSelectedSolution] = useState([]);
    const [selectedMachine, setSelectedMachine] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedCertification, setSelectedCertification] = useState([]);
    const [filteredSelectedIndustry, setFilteredSelectedIndustry] = useState(
        []
    );
    const [filteredSelectedSolution, setFilteredSelectedSolution] = useState(
        []
    );
    const [filteredSelectedMachine, setFilteredSelectedMachine] = useState([]);
    const [filteredSelectedLocation, setFilteredSelectedLocation] = useState(
        []
    );
    const [filteredSelectedCertification, setFilteredSelectedCertification] =
        useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [industryTypeCertification, setIndustryTypeCertification] = useState(
        {}
    );
    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { key: string; title: string }[];
    }>({});
    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [readNew, setNewRead] = useState<Boolean>(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [maxWidth, setMaxWidth] =
        React.useState<DialogProps["maxWidth"]>("xs");
    const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
    const [reasonForRejection, setReasonForRejection] = useState<string>("");
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const popperRef = useRef<HTMLDivElement>(null);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["__check__", "Partner_ID", "Partner_Name"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );
    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setReasonForRejection("");
    };

    const [partnerID, setPartnerID] = useState("");

    const [selectedValue, setSelectedValue] = useState<number>(1);
    const [confirmedAudit, setConfirmedAudit] = useState(false);

    // Function to open drawer and set selected row data
    interface Partner {
        id: number;
        Partner_ID: string;
        Partner_Name: string;
        Industry_Type: string;
        overview: string;
        Certifications: string;
        turnoverRange: string;
        primaryContact: string;
        legalBusinessAddress: string;
        logo: string;
        unique_ID: string;
        reason: string;
        isNew: boolean;
        Notification_ID: string;
        navigatingFrom?: string;
    }
    const handleOpenDrawer = async (row: Partner) => {
        row.navigatingFrom = "Partner Database";
        setSelectedRow(row);
        setOpenDrawer(true);
        if (row?.isNew) {
            notificationUpdateReadStatus(row?.Notification_ID.toString());
        }
    };

    // Function to close drawer
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    const notificationUpdateReadStatus = async (id: string) => {
        try {
            const updateData = await notificationUpdateReadStatusApi({
                notifierID: id
            });
            if (updateData?.status) {
                setNewRead(true);
                updateIsReadStatus === true
                    ? setUpdateIsReadStatus(false)
                    : setUpdateIsReadStatus(true);
            }
        } catch (error) {
            console.log("eeeeeeeeeeeee", error);
        }
    };

    const fetchPartnerData = async (params: string) => {
        setIsLoading(true);
        setNewRead(false);
        try {
            const response = await partnerApi(params);
            setIsLoading(false);
            if (response?.status) {
                let data = response?.data?.map((item: any, index: number) => ({
                    id: index + 1, // DataGrid requires a unique `id` field
                    Partner_ID: item?.Partner_ID || `P${index + 1}`, // Generate an ID if missing
                    Partner_Name: item?.Partner_Name,
                    Audit_Status: item?.Audit_Status,
                    Industry_Type: item?.Industry_Type.join(", "), // Convert array to string
                    overview: item?.Solutions_Offered.join(", "), // Convert array to string
                    Certifications: item?.Certifications?.map(
                        (cert: any) => cert.Certificate_Name
                    ).join(", "), // Convert array to string
                    turnoverRange: item?.Turn_Over_Range,
                    primaryContact: `${item?.Primary_Contact_Name || ""}`,
                    emailId: item?.Primary_Contact_Email || "N/A",

                    legalBusinessAddress: item?.Primary_Contact_Number || "N/A",
                    logo: item?.Logo,
                    unique_ID: item?.Rec_ID,
                    reason: item?.Reason_for_rejection || "No Reason",
                    Stakeholder: item?.Stakeholder,
                    Department: item?.Department,
                    isNew: item?.New,
                    machines: item?.Top_Machines.map(
                        (cert: any) => cert.Machine_category
                    ).join(", "),
                    location: item?.Principal_Place_of_Business,
                    Notification_ID: item?.Notification_ID,
                    Added_Date: item?.Added_Date
                        ? new Intl.DateTimeFormat("en-GB").format(
                              new Date(item.Added_Date)
                          )
                        : null,
                    Last_Updated_On: item?.Last_Updated_On
                        ? new Intl.DateTimeFormat("en-GB").format(
                              new Date(item.Last_Updated_On)
                          )
                        : null
                }));
                setRows(data);
                setFilteredRows(data);
            } else {
                setRows([]);
                setFilteredRows([]);
                // showToast({
                //   message: response?.message,
                //   type: "error",
                // });
            }
        } catch (error) {
            setIsLoading(false);
            setRows([]);
            setFilteredRows([]);
            // showToast({
            //   message: error?.message,
            //   type: "error",
            // });
        }
    };
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
        // if (isInitialRender) {
        //   setIsInitialRender(false); // Mark as rendered
        //   return; // Skip first execution
        // }
        // const fetchdataInUseEffect = async () => {
        if (value === "1") {
            fetchPartnerData("New");
            setAnchorEl(null);
            setSelectedIndustry([]);
            setSelectedSolution([]);
            setSelectedMachine([]);
            setSelectedCertification([]);
            setSelectedLocation([]);
        } else if (value === "2") {
            fetchPartnerData("In Review");
            setAnchorEl(null);
            setSelectedIndustry([]);
            setSelectedSolution([]);
            setSelectedMachine([]);
            setSelectedCertification([]);
            setSelectedLocation([]);
        } else if (value === "3") {
            fetchPartnerData("Approved");
            setAnchorEl(null);
            setSelectedIndustry([]);
            setSelectedSolution([]);
            setSelectedMachine([]);
            setSelectedCertification([]);
            setSelectedLocation([]);
        } else if (value === "4") {
            fetchPartnerData("Rejected");
            setAnchorEl(null);
            setSelectedIndustry([]);
            setSelectedSolution([]);
            setSelectedMachine([]);
            setSelectedCertification([]);
            setSelectedLocation([]);
        }
        // };
        // fetchdataInUseEffect();
    }, [value, updateIsReadStatus]);

    const handleClearAll = () => {
        setSelectedIndustry([]);
        setSelectedSolution([]);
        setSelectedMachine([]);
        setSelectedLocation([]);
        setSelectedCertification([]);
        // setFilteredRows(rows);
        // setIsApplyFilter(false);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedIndustry(filteredSelectedIndustry);
        setSelectedCertification(filteredSelectedCertification);
        setSelectedLocation(filteredSelectedLocation);
        setSelectedMachine(filteredSelectedMachine);
        setSelectedSolution(filteredSelectedSolution);
    };
    const handleClearAllChip = () => {
        setSelectedIndustry([]);
        setSelectedCertification([]);
        setSelectedLocation([]);
        setSelectedMachine([]);
        setSelectedSolution([]);
        setFilteredSelectedIndustry([]);
        setFilteredSelectedCertification([]);
        setFilteredSelectedLocation([]);
        setFilteredSelectedMachine([]);
        setFilteredSelectedSolution([]);

        setFilteredRows(rows);
        setIsApplyFilter(false);
    };

    const open = Boolean(anchorEl);

    // Handle tab change
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
        setSearchTerm(""); // Clear search when switching tabs
        setFilteredRows(rows); // Reset to all rows
        setSelectedRows([]);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["Partner_ID", "Partner_Name"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };

    const handleSelectionChange = (selection: any) => {
        const selectedRowData = rows?.filter((row, index) =>
            selection.includes(index + 1)
        );
        selSelectedRowsForAcceptAndReject(selectedRowData);
        setSelectedRows(selection);
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);

    const industryIcons = {
        "Oil & Gas": oligasIcn,
        "Power & Transmission": power,
        "EV/Automotive": evAutoIcn,
        "Industrial Products": industry,
        "Aerospace & Defence": aerospace
    };

    const IndustryTypeCell = ({
        value,
        isIndustryType
    }: {
        value?: string;
        isIndustryType?: boolean;
    }) => {
        const [expanded, setExpanded] = useState(false);
        const types = value?.split(", ") || [];

        const displayedTypes = expanded ? types : types.slice(0, 2);
        const remainingCount = types.length - 2;

        return (
            <Box
                sx={{
                    gap: 0.5,
                    alignItems: "center",
                    height: "100%",
                    margin: "5px 0 3px"
                }}
            >
                {displayedTypes?.map((type, idx) =>
                    type ? (
                        <Chip
                            key={idx}
                            label={type}
                            size="small"
                            sx={{ margin: "5px 0px 0px 5px" }}
                            avatar={
                                isIndustryType || industryIcons[type] ? (
                                    <img
                                        src={`${industryIcons[type]}`}
                                        alt={type}
                                        style={{ width: 15, height: 15 }}
                                    />
                                ) : null
                            }
                        />
                    ) : (
                        "-"
                    )
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={() => setExpanded(false)}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const handleSelectChange = (event: any, partnerid: string) => {
        setPartnerID(partnerid);
        const value = Number(event.target.value);
        if (value === 2) {
            // Open dialog when "Audit Completed" selected
            setOpenDialog(true);
        } else {
            setSelectedValue(value);
        }
    };

    const handleConfirm = async () => {
        setConfirmedAudit(true);
        setOpenDialog(false);
        try {
            const response = await updateAuditStatyByQH(partnerID);
            if (response?.status === true) {
                showToast({
                    message: `Audit status changed`,
                    type: "success"
                });
                await fetchPartnerData("Approved");
            } else {
                showToast({
                    message: `Somethis went to wrong`,
                    type: "error"
                });
            }
        } catch (err) {
            console.log("error while updating audit status");
        } finally {
            setConfirmedAudit(false);
            setPartnerID("");
        }
    };

    const handleCancel = () => {
        setOpenDialog(false);
        setSelectedValue(1); // Reset to "Physical Audit Pending"
    };
    const shouldShowBadge = (isnew) => {
        if (!isnew) return false;

        if (value === "1" && sourcingManagerHead()) return true;
        if (value === "2" && qualityManagerHead()) return true;

        return false;
    };

    const columns: GridColDef[] = [
        {
            field: "Partner_ID",
            headerName: "ID",
            width: 70,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            height: "100%",
                            cursor: "pointer"
                        }}
                        className="hoverClr"
                        onClick={() => handleOpenDrawer(params.row)}
                    >
                        {params?.value}
                    </Box>
                );
            }
        },
        {
            field: "Partner_Name",
            headerName: "Partner Name",
            minWidth: 300,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                // const uniqueId = params.row.unique_ID; // Get the Unique ID
                const logoUrl = params.row.logo
                    ? generatePartnerRegistrationFile(params?.row?.logo)
                    : defaultlogo;
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            height: "100%",
                            cursor: "pointer"
                        }}
                        onClick={() => handleOpenDrawer(params.row)}
                    >
                        {logoUrl && (
                            <img
                                src={logoUrl}
                                alt={name}
                                width={28}
                                height={28}
                                style={{
                                    borderRadius: "50%",
                                    border: "1px solid #D8D8D8"
                                }}
                            />
                        )}
                        <Typography
                            variant="body2"
                            className="hoverClr"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center"
                            }}
                        >
                            <span style={{ paddingRight: "5px" }}>
                                {truncatedName}
                            </span>
                            {shouldShowBadge(params.row.isNew) && (
                                // <Chip label={"New"} size="small" color="primary" />
                                <CircleIcon
                                    sx={{ fontSize: "12px", color: " #1976d2" }}
                                />
                            )}
                        </Typography>
                    </Box>
                );
            }
        },

        {
            field: "Industry_Type",
            headerName: "Industry Type",
            width: 300,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IndustryTypeCell value={params.value} isIndustryType={true} />
            )
        },

        {
            field: "overview",
            headerName: "Solutions offered",
            width: 300,
            disableColumnMenu: true,
            renderCell: (params) => <IndustryTypeCell value={params.value} />
        },

        {
            field: "Certifications",
            headerName: "Certification",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => <IndustryTypeCell value={params?.value} />
        },

        {
            field: "turnoverRange",
            headerName: "Turn Over Range",
            width: 180,
            disableColumnMenu: true
        },

        {
            field: "primaryContact",
            headerName: "Primary Contact Name",
            width: 250,
            disableColumnMenu: true
        },
        {
            field: "legalBusinessAddress",
            headerName: "Contact Number",
            width: 250,
            disableColumnMenu: true
        },
        {
            field: "emailId",
            headerName: "Email",
            width: 250,
            disableColumnMenu: true
        },

        {
            field: "Added_Date",
            headerName: "Added On",
            width: 150,
            disableColumnMenu: true
        },
        // {
        //   field: "Last_Updated_On",
        //   headerName: "Last Updated On",
        //   width: 150,
        //   disableColumnMenu: true,
        // },
        ...(value !== "1"
            ? [
                  {
                      field: "Last_Updated_On",
                      headerName: "Last Updated On",
                      width: 150,
                      disableColumnMenu: true,
                      sortComparator: (v1, v2) =>
                          new Date(v1).getTime() - new Date(v2).getTime()
                  }
              ]
            : [])
    ];

    const approvalColumns = value === "3" && [
        {
            field: "Audit_Status",
            headerName: "Audit status",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <>
                        {qualityManager() || qualityManagerHead() ? (
                            params.row.Audit_Status === "Audit Completed" ? (
                                <Chip
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    label="Audit Completed"
                                />
                            ) : (
                                <Select
                                    value={selectedValue}
                                    input={<BootstrapInput />}
                                    onChange={(event) =>
                                        handleSelectChange(
                                            event,
                                            params.row.Partner_ID
                                        )
                                    }
                                >
                                    <MenuItem value={1}>
                                        <Chip
                                            variant="outlined"
                                            color="warning"
                                            size="small"
                                            label="Physical Audit Pending"
                                        />
                                    </MenuItem>
                                    <MenuItem value={2}>
                                        <Chip
                                            variant="outlined"
                                            color="success"
                                            size="small"
                                            label="Audit Completed"
                                        />
                                    </MenuItem>
                                </Select>
                            )
                        ) : params.row.Audit_Status === "Audit Completed" ? (
                            <Chip
                                variant="outlined"
                                color="success"
                                size="small"
                                label="Audit Completed"
                            />
                        ) : (
                            <Chip
                                variant="outlined"
                                color="warning"
                                size="small"
                                label="Physical Audit Pending"
                            />
                        )}
                        {/* Dialog for confirmation */}
                        <Dialog
                            open={openDialog}
                            onClose={handleCancel}
                            fullWidth
                            BackdropProps={{
                                sx: {
                                    backgroundColor: "rgba(32, 32, 32, 0.5)",
                                    PaperShadow:
                                        "0px 11px 15px -7px rgba(0, 0, 0, 0), 0px 24px 38px 3px rgba(0, 0, 0, 0), 0px 9px 46px 8px rgba(0, 0, 0, 0)"
                                }
                            }}
                            aria-labelledby="responsive-dialog-title"
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    right: "0",
                                    padding: "10px",
                                    color: "#B1B1B1",
                                    cursor: "pointer"
                                }}
                            >
                                <CloseIcon onClick={handleCancel} />
                            </div>
                            <DialogTitle
                                id="responsive-dialog-title"
                                sx={{ paddingBottom: "5px" }}
                                fontWeight={"bold"}
                            >
                                Confirm Audit Completion
                            </DialogTitle>
                            <DialogContent sx={{ paddingBottom: "10px" }}>
                                <DialogContentText>
                                    Are you sure the physical audit was
                                    completed for this partner? This Action is
                                    one time and not reversible.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCancel} color="error">
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleConfirm}
                                    color="primary"
                                    disabled={confirmedAudit}
                                >
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.modal + 1,
                                backgroundColor: "rgba(0,0,0,0.7)"
                            }}
                            open={confirmedAudit}
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Backdrop>
                    </>
                );
            }
        }
    ];

    const additionalColumns = value === "4" && [
        {
            field: "reason",
            headerName: "Reason for rejection",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Typography
                        variant="body2"
                        display="flex"
                        alignItems="center"
                    >
                        {params.value}

                        <Tooltip
                            title={`${params.row.Stakeholder}, ${params.row.Department}`}
                        >
                            <IconButton>
                                <InfoOutlinedIcon
                                    style={{ fontSize: "16px" }}
                                />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                );
            }
        }
    ];
    const approval_Column = columns.concat(approvalColumns);
    const finalColumns = columns.concat(additionalColumns);

    // const partnerMessages: Record<string, string> = {
    //   "1": "Onboarded Partners will be visible here",
    //   "2":
    //     qualityManager() || qualityManagerHead()
    //       ? "Onboarded partners will be visible here"
    //       : "Partners approved by sourcing head will be visible here",
    //   "3": "Approved partners will be visible here",
    //   "4": "Rejected partners will be visible here",
    // };

    const partnerMessages: Record<string, string> = {
        "1": "Newly onboarded partners will appear here",
        "2": "Partners who are under review will appear here",
        "3": "Approved partners will appear here",
        "4": "Rejected partners will appear here"
    };

    function extractOptions(apiResponse, keyName: string) {
        const section = apiResponse?.find(
            (item) => Object.keys(item)[0] === keyName
        );

        if (!section || !section[keyName]?.choices) return [];

        return section[keyName].choices.flatMap((item) => {
            // Handle Certificate_Name and Machine_category separately
            if (
                item?.link_name === "Certificate_Name" ||
                item?.link_name === "Machine_category"
            ) {
                return item?.choices
                    ?.filter((element) => element.value && element.value !== 0) // Ensure value is not empty or 0
                    ?.map((element) => ({
                        key: element.key,
                        title: element.value
                    }));
            }

            // Handle other categories
            if (item?.value && item?.value !== 0) {
                return {
                    key: item?.key || item?.link_name,
                    title: item?.value || item?.link_name
                };
            }

            return [];
        });
    }

    const fetchFilterData = async () => {
        try {
            const filterData = await fetchDataForDisplayDataInDropDownApi();
            if (filterData?.status) {
                const apiResponse = filterData?.data;
                const industryOptions = extractOptions(apiResponse, "Industry");
                const solutionOptions = extractOptions(
                    apiResponse,
                    "Solutions_You_Offer"
                );
                const certificationOptions = extractOptions(
                    apiResponse,
                    "Certifications"
                );
                const machinesOptions = extractOptions(
                    apiResponse,
                    "List_of_Top_machines"
                );
                setIndustryTypeCertification(
                    apiResponse[0]?.IndustryCertification
                );
                const obj = {
                    industryOptions,
                    solutionOptions,
                    certificationOptions,
                    machinesOptions
                };

                setFilterOptions(obj);
            }
        } catch (error) {
            console.log("errrrrrrrrrrrrrrrrr", error);
        }
    };
    useEffect(() => {
        if (selectedIndustry?.length) {
            // Get default certifications
            const defaultCertifications = [
                ...(industryTypeCertification["GST"] || []),
                ...(industryTypeCertification["MSME"] || []),
                ...(industryTypeCertification["IEC Importer Exporter"] || [])
            ];

            // Get industry-specific certifications
            const industryCertifications = selectedIndustry
                .map((item) => industryTypeCertification[item.title] || [])
                .flat();

            // Merge and remove duplicates, then convert back to array
            const mergedCertifications = Array.from(
                new Set([...defaultCertifications, ...industryCertifications])
            );

            // Format options
            const certificationOptions = mergedCertifications.map((item) => ({
                key: item,
                title: item
            }));

            // Update state
            setFilterOptions((prevOptions) => ({
                ...prevOptions,
                certificationOptions
            }));
        } else {
            setFilterOptions((prevOptions) => ({
                ...prevOptions,
                certificationOptions: []
            }));
        }
    }, [selectedIndustry]);

    const filterData = (rows, filters) => {
        return rows?.filter((row) => {
            // Convert row values to lowercase arrays for comparison
            const industryArray =
                row?.Industry_Type?.toLowerCase().split(/\s*,\s*/) || [];
            const solutionArray =
                row?.overview?.toLowerCase().split(/\s*,\s*/) || [];
            const certificationArray =
                row?.Certifications?.toLowerCase().split(/\s*,\s*/) || [];
            const machineArray =
                row?.machines?.toLowerCase().split(/\s*,\s*/) || [];
            const locationArray =
                row?.location?.toLowerCase().split(/\s*,\s*/) || [];

            // Get filter values, ignore empty ones
            const {
                industry = [],
                solution = [],
                certification = [],
                machine = [],
                location = []
            } = filters;

            // Check if each applied filter matches
            const industryMatch =
                industry.length === 0 ||
                industry.some((ind) =>
                    industryArray.includes(ind.toLowerCase())
                );
            const solutionMatch =
                solution.length === 0 ||
                solution.some((sol) =>
                    solutionArray.includes(sol.toLowerCase())
                );
            const certificationMatch =
                certification.length === 0 ||
                certification.some((cert) =>
                    certificationArray.includes(cert.toLowerCase())
                );
            const machineMatch =
                machine.length === 0 ||
                machine.some((m) => machineArray.includes(m.toLowerCase()));
            const locationMatch =
                location.length === 0 ||
                location.some((loc) =>
                    locationArray.includes(loc.toLowerCase())
                );

            // **Must match ALL applied filters**
            return (
                industryMatch &&
                solutionMatch &&
                certificationMatch &&
                machineMatch &&
                locationMatch
            );
        });
    };

    const handleApply = async () => {
        setIsApplyFilter(true);
        let filters = {
            industry:
                selectedIndustry?.map((item) => item?.title.toLowerCase()) ||
                [],
            solution:
                selectedSolution?.map((item) => item?.title.toLowerCase()) ||
                [],
            certification:
                selectedCertification?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            machine:
                selectedMachine?.map((item) => item?.title.toLowerCase()) || [],
            location:
                selectedLocation?.map((item) => item?.title.toLowerCase()) || []
        };

        const filteredResults = filterData(rows, filters);
        setFilteredRows(filteredResults);
        setAnchorEl(null);
        setFilteredSelectedIndustry(selectedIndustry);
        setFilteredSelectedCertification(selectedCertification);
        setFilteredSelectedLocation(selectedLocation);
        setFilteredSelectedMachine(selectedMachine);
        setFilteredSelectedSolution(selectedSolution);
        if (
            selectedIndustry?.length == 0 &&
            selectedSolution?.length == 0 &&
            selectedCertification?.length == 0 &&
            selectedLocation?.length == 0 &&
            selectedMachine?.length == 0
        ) {
            setFilteredRows(rows);
            setFilteredSelectedIndustry(selectedIndustry);
            setFilteredSelectedCertification(selectedCertification);
            setFilteredSelectedLocation(selectedLocation);
            setFilteredSelectedMachine(selectedMachine);
            setFilteredSelectedSolution(selectedSolution);
        }
    };

    useEffect(() => {
        fetchFilterData();
    }, []);

    const handleAcceptAndReject = async (status: string) => {
        const payload = selectedRowsForAcceptAndReject?.map((item) => {
            return {
                partnerId: item.unique_ID,
                partnerName: item.Partner_Name,
                partner_status: status,
                stakeholder: loggedinguserid,
                partnerEmail: "k.yogesh@machinemaze.com",
                reason_for_rejection:
                    status === "Rejected" ? reasonForRejection : "In Review",
                userEmail: getLoggedInEmail(),
                notificationID: item?.Notification_ID
            };
        });

        try {
            setIsButtonDisable(true);
            const acceptAndRejectData = await approveAndRejectApi(payload);
            setReasonForRejection(null);
            if (acceptAndRejectData?.status === true) {
                setSelectedRows([]);
                showToast({
                    message:
                        status === "In Review" || status === "Approved"
                            ? `Partner(s) approved`
                            : `Partner(s) rejected`,
                    type: status === "Rejected" ? "error" : "success"
                });

                // Fetch the correct tab data
                if (qualityManager() || qualityManagerHead()) {
                    // If quality user, refresh "Approved" tab after acceptance
                    fetchPartnerData("In Review");
                } else {
                    // Otherwise, refresh "New" tab after acceptance/rejection
                    fetchPartnerData("New");
                }

                setIsButtonDisable(false);
            } else {
                setIsButtonDisable(false);
                showToast({
                    message: acceptAndRejectData?.message,
                    type: "error"
                });
            }
        } catch (err) {
            setIsButtonDisable(false);

            showToast({
                message: err?.message,
                type: "error"
            });
        } finally {
            setOpenDialog(false);
        }
    };

    const handleRemoveFilter = (category, item) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "industry":
                setSelectedIndustry((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "solution":
                setSelectedSolution((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "certification":
                setSelectedCertification((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "machine":
                setSelectedMachine((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "location":
                setSelectedLocation((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };

    // Run `handleApply` after any filter changes
    useEffect(() => {
        handleApply();
        if (
            selectedIndustry.length === 0 &&
            selectedSolution.length == 0 &&
            selectedCertification.length == 0 &&
            selectedMachine.length == 0 &&
            selectedLocation.length == 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    useEffect(() => {
        try {
            if (!messages) return; // Prevent parsing if it's undefined or null

            const message = Array.isArray(messages) ? messages[0] : messages;

            if (typeof message !== "string") {
                console.log("Invalid JSON: Not a string", message);
                return;
            }

            const messageParse = JSON.parse(message);
            if (messageParse.type === "data_moved_to_InReview") {
                if (
                    value === "2" &&
                    (qualityManagerHead() || qualityManager())
                ) {
                    setTimeout(() => {
                        fetchPartnerData("In Review");
                    }, 3000);
                }
            }
        } catch (error) {
            console.log("Invalid JSON:", error);
        }
    }, [messages]);

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                    Partner Database
                </Typography>
            </Breadcrumbs>

            <Typography variant="h5" mb={1}>
                List of Partner Responses
            </Typography>

            <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                    <Box>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            {!(qualityManager() || qualityManagerHead()) && (
                                <Tab label="NEW" value="1" />
                            )}

                            <Tab label="IN REVIEW" value="2" />
                            <Tab label="APPROVED" value="3" />
                            <Tab label="REJECTED" value="4" />
                        </TabList>
                    </Box>
                    <StyledTabPanel value={value}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                {rows?.length > 1 && (
                                    <Grid container spacing={2}>
                                        {/* Search Section */}
                                        <Grid size={{ xs: 12, md: 7 }}>
                                            <TextField
                                                label="Search by ID & Partner Name"
                                                size="small"
                                                variant="outlined"
                                                fullWidth
                                                inputRef={searchInputRef}
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                        </Grid>
                                        {/* Filter section */}
                                        <Grid
                                            size={{ xs: 12, md: 5 }}
                                            sx={{
                                                color: "grey",
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Box>
                                                <IconButton
                                                    onClick={handleClick}
                                                >
                                                    <Badge
                                                        badgeContent={
                                                            filteredSelectedIndustry?.length +
                                                            filteredSelectedCertification?.length +
                                                            filteredSelectedLocation?.length +
                                                            filteredSelectedMachine?.length +
                                                            filteredSelectedSolution?.length
                                                        }
                                                        color="primary"
                                                    >
                                                        <FilterAltOutlinedIcon />
                                                    </Badge>
                                                </IconButton>
                                                <Popper
                                                    open={Boolean(anchorEl)}
                                                    anchorEl={anchorEl}
                                                    placement="bottom-start"
                                                    sx={{ zIndex: 13 }}
                                                >
                                                    <Paper
                                                        ref={popperRef}
                                                        sx={{
                                                            p: 2,
                                                            width: 350,
                                                            boxShadow: 3,
                                                            borderRadius: 2
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                fontWeight:
                                                                    "bold",
                                                                mb: 2,
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between"
                                                            }}
                                                        >
                                                            Filter{" "}
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={
                                                                    handleClearAll
                                                                }
                                                            >
                                                                CLEAR ALL
                                                            </Button>
                                                        </Box>

                                                        <Box sx={{ mb: 2 }}>
                                                            <Autocomplete
                                                                multiple
                                                                limitTags={2}
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                size="small"
                                                                id="multiple-limit-tags"
                                                                value={
                                                                    selectedIndustry
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedIndustry(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                options={[
                                                                    ...(filterOptions?.industryOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                renderOption={(
                                                                    props,
                                                                    option
                                                                ) => (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            display:
                                                                                "flex",
                                                                            alignItems:
                                                                                "center",
                                                                            gap: 10
                                                                        }}
                                                                    >
                                                                        <Typography>
                                                                            {
                                                                                option.title
                                                                            }
                                                                        </Typography>
                                                                    </li>
                                                                )}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Industry"
                                                                        placeholder="Select Industry Type"
                                                                    />
                                                                )}
                                                            />

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.solutionOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                value={
                                                                    selectedSolution
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedSolution(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Solution Offered"
                                                                        placeholder="Select Solution Offered"
                                                                    />
                                                                )}
                                                            />
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.certificationOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                value={
                                                                    selectedCertification
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedCertification(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                disabled={
                                                                    (
                                                                        selectedIndustry ||
                                                                        []
                                                                    ).length ==
                                                                    0
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Certifications"
                                                                        placeholder="Select Certifications"
                                                                        // disabled={
                                                                        //   (selectedIndustry || []).length == 0
                                                                        // }
                                                                    />
                                                                )}
                                                            />
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.machinesOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedMachine
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedMachine(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Machines"
                                                                        placeholder="Select Machines"
                                                                    />
                                                                )}
                                                            />
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedLocation
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedLocation(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                options={[
                                                                    ...locationOptions
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Location"
                                                                        placeholder="Select Location"
                                                                    />
                                                                )}
                                                            />
                                                        </Box>

                                                        {/* Apply / Cancel Buttons */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between",
                                                                mt: 2
                                                            }}
                                                        >
                                                            <Button
                                                                onClick={
                                                                    handleClose
                                                                }
                                                                color="secondary"
                                                            >
                                                                CANCEL
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={
                                                                    handleApply
                                                                }
                                                            >
                                                                APPLY
                                                            </Button>
                                                        </Box>
                                                    </Paper>
                                                </Popper>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                {(qualityManager() || qualityManagerHead()
                                    ? value === "2"
                                    : value === "1") &&
                                    selectedRows?.length > 0 && (
                                        <>
                                            <div style={{ float: "right" }}>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    disabled={isButtonDisable}
                                                    onClick={
                                                        handleClickOpenDialog
                                                    }
                                                    sx={{ marginRight: "10px" }}
                                                >
                                                    Reject
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    disabled={isButtonDisable}
                                                    onClick={() =>
                                                        handleAcceptAndReject(
                                                            sourcingManager() ||
                                                                sourcingManagerHead()
                                                                ? "In Review"
                                                                : "Approved"
                                                        )
                                                    }
                                                >
                                                    Approve
                                                </Button>
                                                <Dialog
                                                    open={openDialog}
                                                    onClose={handleCloseDialog}
                                                    maxWidth={maxWidth}
                                                    fullWidth
                                                    aria-labelledby="responsive-dialog-title"
                                                >
                                                    <DialogTitle
                                                        id="responsive-dialog-title"
                                                        fontWeight={"bold"}
                                                    >
                                                        {"Reject Partner(s)"}
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <Typography
                                                            sx={{
                                                                color: "text.secondary",
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                        >
                                                            Are you sure you
                                                            want to reject the
                                                            partner(s)?
                                                        </Typography>
                                                        <TextField
                                                            id="outlined-multiline-static"
                                                            label="Add your comments"
                                                            multiline
                                                            rows={4}
                                                            value={
                                                                reasonForRejection
                                                            }
                                                            onChange={(e) =>
                                                                setReasonForRejection(
                                                                    e?.target
                                                                        ?.value
                                                                )
                                                            }
                                                            InputLabelProps={{
                                                                shrink: true
                                                            }}
                                                            fullWidth
                                                        />
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button
                                                            autoFocus
                                                            color="error"
                                                            onClick={
                                                                handleCloseDialog
                                                            }
                                                        >
                                                            Cancel
                                                        </Button>
                                                        {/* <Button
                              disabled={
                                reasonForRejection?.length <= 0 ||
                                isButtonDisable
                              }
                              onClick={() => handleAcceptAndReject("Rejected")}
                              autoFocus
                            >
                              {!isButtonDisable ? "Submit" : "Submitting"}
                            </Button> */}
                                                        <Button
                                                            disabled={
                                                                reasonForRejection.trim()
                                                                    .length ===
                                                                    0 ||
                                                                isButtonDisable
                                                            }
                                                            onClick={() =>
                                                                handleAcceptAndReject(
                                                                    "Rejected"
                                                                )
                                                            }
                                                            autoFocus
                                                        >
                                                            {!isButtonDisable
                                                                ? "Submit"
                                                                : "Submitting"}
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </div>
                                        </>
                                    )}
                            </Grid>
                            <Grid size={{ xs: 12, md: 12 }}>
                                {/* Selected Filters as Chips */}
                                {isApplyFilter == true && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 1
                                        }}
                                        mb={2}
                                    >
                                        {filteredSelectedIndustry?.map(
                                            (item, index) => (
                                                <Chip
                                                    key={`industry-${index}`}
                                                    label={item?.title}
                                                    onDelete={() =>
                                                        handleRemoveFilter(
                                                            "industry",
                                                            item
                                                        )
                                                    }
                                                    size="small"
                                                />
                                            )
                                        )}
                                        {filteredSelectedSolution?.map(
                                            (item, index) => (
                                                <Chip
                                                    key={`solution-${index}`}
                                                    label={item.title}
                                                    onDelete={() =>
                                                        handleRemoveFilter(
                                                            "solution",
                                                            item
                                                        )
                                                    }
                                                    size="small"
                                                />
                                            )
                                        )}
                                        {filteredSelectedCertification?.map(
                                            (item, index) => (
                                                <Chip
                                                    key={`certification-${index}`}
                                                    label={item?.title}
                                                    onDelete={() =>
                                                        handleRemoveFilter(
                                                            "certification",
                                                            item
                                                        )
                                                    }
                                                    size="small"
                                                />
                                            )
                                        )}
                                        {filteredSelectedMachine?.map(
                                            (item, index) => (
                                                <Chip
                                                    key={`machine-${index}`}
                                                    label={item?.title}
                                                    onDelete={() =>
                                                        handleRemoveFilter(
                                                            "machine",
                                                            item
                                                        )
                                                    }
                                                    size="small"
                                                />
                                            )
                                        )}
                                        {filteredSelectedLocation?.map(
                                            (item, index) => (
                                                <Chip
                                                    key={`location-${index}`}
                                                    label={item.title}
                                                    onDelete={() =>
                                                        handleRemoveFilter(
                                                            "location",
                                                            item
                                                        )
                                                    }
                                                    size="small"
                                                />
                                            )
                                        )}
                                        {/* Clear All Button - Show only when filters exist */}
                                        {filteredSelectedIndustry?.length +
                                            filteredSelectedCertification?.length +
                                            filteredSelectedLocation?.length +
                                            filteredSelectedMachine?.length +
                                            filteredSelectedSolution?.length >
                                            0 && (
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={handleClearAllChip}
                                                sx={{
                                                    fontSize:
                                                        ".75rem !important",
                                                    lineHeight: "1",
                                                    borderRadius: "30px"
                                                }}
                                            >
                                                CLEAR ALL
                                            </Button>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                        <Paper
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height:
                                    filteredRows?.length > 4
                                        ? "56vh"
                                        : filteredRows?.length > 0
                                          ? "auto"
                                          : "61vh"
                            }}
                        >
                            {!isButtonDisable && !isLoading ? (
                                filteredRows?.length > 0 ? (
                                    <DataGridPro
                                        // Removed autoHeight
                                        pinnedColumns={pinnedColumns}
                                        onPinnedColumnsChange={
                                            handlePinnedColumnsChange
                                        }
                                        getRowHeight={() => "auto"}
                                        rows={filteredRows}
                                        columns={
                                            value === "4"
                                                ? finalColumns
                                                : value === "3"
                                                  ? approval_Column
                                                  : columns
                                        }
                                        pagination={filteredRows?.length > 10}
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={
                                            setPaginationModel
                                        }
                                        pageSizeOptions={[10, 20]}
                                        checkboxSelection={
                                            Management() ||
                                            sourcingManager() ||
                                            qualityManager() ||
                                            NPDManagerHead() ||
                                            NPDManager() ||
                                            productionManager() ||
                                            productionManagerHead()
                                                ? false
                                                : !qualityManagerHead()
                                                  ? value === "1"
                                                  : value === "2"
                                        }
                                        rowSelectionModel={selectedRows}
                                        onRowSelectionModelChange={
                                            handleSelectionChange
                                        }
                                        disableRowSelectionOnClick={true}
                                        initialState={{
                                            sorting: {
                                                sortModel: [
                                                    {
                                                        field: "Last_Updated_On",
                                                        sort: "desc"
                                                    }
                                                ]
                                            }
                                        }}
                                        sx={{
                                            width: "100%",
                                            "& .MuiDataGrid-columnHeaderTitleContainer":
                                                {
                                                    "& .MuiDataGrid-sortIcon": {
                                                        opacity: "1 !important",
                                                        visibility:
                                                            "visible !important"
                                                    }
                                                },
                                            "& .MuiDataGrid-cell": {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                                {
                                                    backgroundColor:
                                                        "#F4F4F4!important"
                                                }
                                        }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "20px",
                                            color: "#0009"
                                        }}
                                    >
                                        {(searchTerm &&
                                            filteredRows.length == 0) ||
                                        (isApplyFilter &&
                                            filteredRows.length == 0) ? (
                                            "No partner found"
                                        ) : (
                                            <>
                                                <img
                                                    src={emptyImage}
                                                    alt="Empty"
                                                    width={"300px"}
                                                />
                                                <b>
                                                    {partnerMessages[value] ||
                                                        "Unknown Status"}
                                                </b>
                                            </>
                                        )}
                                    </div>
                                )
                            ) : (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="50vh"
                                >
                                    <ThreeDot
                                        color="#1976d2"
                                        size="medium"
                                        text=""
                                        textColor=""
                                    />
                                </Box>
                            )}
                        </Paper>

                        <PartnerDetailsDrawer
                            open={openDrawer}
                            onClose={handleCloseDrawer}
                            selectedPartner={selectedRow}
                        />
                    </StyledTabPanel>
                </TabContext>
            </Box>
        </>
    );
};
